<div class="tab-buttons">
    <button (click)="onViewChange('personal')">Pessoal</button>
    <button (click)="onViewChange('hashtag')">Hashtag</button>
    <button (click)="onViewChange('mention')">Menções</button>
    <button (click)="onViewChange('tag')">Tags</button>
</div>

<div class="feed-grid">
    <div *ngFor="let m of mediaList" class="media-card">
        <a [href]="m.permalink" target="_blank">
            <img [src]="m.media_url" alt="{{ m.caption }}" />
        </a>
        <p>{{ m.caption }}</p>
        <small>{{ m.timestamp | date:'short' }}</small>
    </div>
</div>